import XAPPService from "app/Core/services/XAPPService";
import _ from "lodash";
export const GET_EMPRESAPESSOAPRODUTO = "[EMPRESAPESSOAPRODUTO APP] GET EMPRESAPESSOAPRODUTO";
export const REMOVE_EMPRESAPESSOAPRODUTO = "[EMPRESAPESSOAPRODUTO APP] REMOVE EMPRESAPESSOAPRODUTO";
export const ADD_EMPRESAPESSOAPRODUTO = "[EMPRESAPESSOAPRODUTO APP] ADD EMPRESAPESSOAPRODUTO";
export const EMPRESAPESSOAPRODUTO_WARNING = "[EMPRESAPESSOAPRODUTO APP] EMPRESAPESSOAPRODUTO WARNING";
export const EMPRESAPESSOAPRODUTO_INFO = "[EMPRESAPESSOAPRODUTO APP] EMPRESAPESSOAPRODUTO INFO";
export const EMPRESAPESSOAPRODUTO_ERROR = "[EMPRESAPESSOAPRODUTO APP] EMPRESAPESSOAPRODUTO ERROR";

const ListState = [
    "idpessoaformulariorelacionamento",
    "idpessoaformulario",
    "idparent",
    "nome",
    "valor",
    "formulario",
    "statusregistro",
];

export function list(_AAction, _AParams, _AID, _ATipo = "pessoa") {
    return (dispatch) => {
        let AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AID }];
        let AConditionsOR = [];
        let AActions = [];
        let Atarget = "spvwempresaprodutopessoa";

        if (_ATipo === "pessoa") {
            Atarget = "spvwempresapessoaproduto";
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoaProduto", AActions, Atarget, ListState, _AAction, AConditionsAND, AConditionsOR);


        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOAPRODUTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AAction, _AValue, _AParams, _ACallback) {
    return (dispatch) => {
        let AddState = [
            "idpessoaformulario",
            "idparent",
            "tipo",
            "idpessoa",
            "formulario",
        ];
        let AConditionsAND = [
            { "Campo": "idpessoaformulariorelacionamento", "Operador": "=", "Valor": _AValue.idpessoaformulariorelacionamento }
        ];
        let AConditionsOR = [];
        let AActions = [];

        if (_AAction === "ATUALIZAR") {
            AddState = ["formulario"];
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulariorelacionamento", _AAction, _AValue, "idpessoaformulariorelacionamento", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAPRODUTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAPRODUTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAPESSOAPRODUTO,
        payload: null
    };
}